import React from 'react'

const Pagination = ({pageNo, length}) => {
  return ( 
    <div className='max-w-6xl flex px-10 justify-center container mx-auto pt-5'>
        <div className="flex flex-col items-center">
              <span className="text-sm text-gray-700">
                  Last <span className="font-semibold text-gray-900">{pageNo} </span>escalations out of <span className="font-semibold text-gray-900">{length}</span>
              </span>
        </div>
    </div>
  )
}

export default Pagination